import './custom-shader'



// WEBPACK FOOTER //
// ./src/aframe/shaders/index.js